<template>
  <div class="gnb_wrap">
    <div class="inner">
      <nav class="gnb">
        <ul v-if="tenantId !== '201'">
          <li class="depth1">
            <router-link
              :to="{ name: 'project' }"
              class="task"
              v-bind:class="{
                active: $router.history.current.name === 'project',
              }"
              >{{ $i18nUtil.trans("button.MainLeft.work","과제") }}</router-link
            >
          </li>
          <li class="depth1" v-if="sharUse === 'true'">
            <router-link
              :to="{ name: 'shareInfo' }"
              class="share"
              v-bind:class="{
                active: $router.history.current.name === 'shareInfo',
              }"
              >{{ $i18nUtil.trans("button.MainLeft.shareInfo","정보") }}</router-link
            >
          </li>
          <li class="depth1" v-if="cfrcUse === 'true'">
            <router-link
              :to="{ name: 'cooperation' }"
              class="coop"
              v-bind:class="{
                active: $router.history.current.name === 'cooperation',
              }"
              >{{ $i18nUtil.trans("button.MainLeft.cooperation","회의") }}</router-link
            >
          </li>
          <li class="depth1" :class="{'side-hover' : tenantId !== '418502'}" id="okrMenuBar" 
            v-if="(accessType === 'IN' && okrUse === 'true') || (externalOkrUse === 'true') ? true : false">
              <a href="#" class="okr" v-if="tenantId !== '418502'" @click="goOkrMain">{{ $i18nUtil.trans("button.MainLeft.okr","OKR") }}</a>
              <a href="#" class="okr sec" v-if="tenantId === '418502'" @click="viewOkrWindow">{{ $i18nUtil.trans("button.MainLeft.okr","OKR") }}</a>
              <div class="hover">
                <span>{{ $i18nUtil.trans("button.MainLeft.okr","OKR") }}</span>
                <div class="scroll">
                  <keep-alive>
                    <component ref="okrSubMenu" v-if="okrSubMenuHtml" :is="okrSubMenu"/>
                  </keep-alive>
                </div>
              </div>
          </li>
        </ul>
        <ul v-if="tenantId === '201'">
          <li class="depth1" :class="{'side-hover' : tenantId !== '418502'}" id="okrMenuBar" 
            v-if="(accessType === 'IN' && okrUse === 'true') || (externalOkrUse === 'true') ? true : false">
              <a href="#" class="okr" v-if="tenantId !== '418502'" @click="goOkrMain">{{ $i18nUtil.trans("button.MainLeft.okr","OKR") }}</a>
              <div class="hover">
                <span>{{ $i18nUtil.trans("button.MainLeft.okr","OKR") }}</span>
                <div class="scroll">
                  <keep-alive>
                    <component ref="okrSubMenu" v-if="okrSubMenuHtml" :is="okrSubMenu"/>
                  </keep-alive>
                </div>
              </div>
          </li>
          <li class="depth1">
            <router-link
              :to="{ name: 'project' }"
              class="task"
              v-bind:class="{
                active: $router.history.current.name === 'project',
              }"
              >{{ $i18nUtil.trans("button.MainLeft.work","과제") }}</router-link
            >
          </li>
          <li class="depth1" v-if="sharUse === 'true'">
            <router-link
              :to="{ name: 'shareInfo' }"
              class="share"
              v-bind:class="{
                active: $router.history.current.name === 'shareInfo',
              }"
              >{{ $i18nUtil.trans("button.MainLeft.shareInfo","정보") }}</router-link
            >
          </li>
          <li class="depth1" v-if="cfrcUse === 'true'">
            <router-link
              :to="{ name: 'cooperation' }"
              class="coop"
              v-bind:class="{
                active: $router.history.current.name === 'cooperation',
              }"
              >{{ $i18nUtil.trans("button.MainLeft.cooperation","회의") }}</router-link
            >
          </li>
        </ul>
      </nav>
      <ul class="util">
        <li v-if="tenantId !== '201'">
          <router-link :to="{ name: 'myPage' }">
            <button type="button" v-html="$i18nUtil.trans('button.MainLeft.mypage','나의 공간')"></button>
          </router-link>
          <a href="javascript:;" @click="showTodo">
            <!-- [할 일 명칭] 증권: 나의 할일, 그 외: 할 일 -->
            <button type="button" v-html="todoNewCheck()">
              <!-- <span class="ico-new" v-if="todoConfirmYn"></span> -->
            </button>
          </a>
        </li>
        <li v-if="tenantId === '203' && tenantId !== '201'">
          <!-- 증권 팀원 할 일 추가 -->
          <a href="javascript:;" @click="showTodoTeam" v-if="roleTypeUser">
            <button type="button" v-html="$i18nUtil.trans('button.MainLeft.teamActivity','팀원 현황')"></button>
          </a>
          <a href="javascript:;" @click="showTodoTeam" v-if="!roleTypeUser">
            <button type="button" v-html="$i18nUtil.trans('button.MainLeft.teamtodo','팀원 할일', {todo: todo})"></button>
          </a>
        </li>
        <li>
          <button type="button" @click="showDecision" 
                  v-html="decisionNewCheck">
          </button>
        </li>
        <li>
          <button type="button" @click="showNoti">
            {{ $i18nUtil.trans("button.MainLeft.Alarm","알림") }}<span class="ico-new" v-if="noneNotiReadYn"></span>
          </button>
        </li>
        <li>
          <button type="button" @click="showTargetCall">
            {{ $i18nUtil.trans("title.TargetCall.001","호출") }}<span class="ico-new" v-if="noneCallReadYn"></span>
          </button>
        </li>
        <ul class="admin_box">
          <!-- <li><button type="button">컨텐츠<br>관리자</button></li> -->
          <li>
            <button type="button" @click="otpYn" v-if="this.roleUserFnc">{{ $i18nUtil.trans("button.MainLeft.manager","관리자") }}</button>
          </li>
        </ul>
      </ul>
      <form ref="HR_OKR_SLO_IF">
        <input type="hidden" id="slo_p_ota" name="slo_p_ota" />
        <input type="hidden" id="gwCode" name="gwCode" />
        <input type="hidden" id="targetUrl" name="targetUrl" />
      </form>
    </div>
  </div>
</template>
<style scoped>
.okr-left-dropdown {
  display: inline-block;
  position: relative;
  margin: 35px 0 15px;
  background: #fff;
}
.okr-left-dropdown button {
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  text-align: left;
}
.okr-left-dropdown button span {
  position: relative;
  display: block;
}
.okr-left-dropdown .btn {
  width: 100%;
  height: 30px;
  border: 1px solid #a3a4a6;
}
.okr-left-dropdown .btn span {
  display: block;
  overflow: hidden;
  width: 100%;
  height: 30px;
  padding: 0 30px 0 15px;
  line-height: 28px;
  box-sizing: border-box;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.okr-left-dropdown .btn span:after {
  content: "";
  position: absolute;
  top: 8px;
  right: 10px;
  width: 6px;
  height: 6px;
  border: 1.2px solid #000;
  border-top: 0;
  border-right: 0;
  transform: rotate(-45deg);
}
.okr-left-dropdown.active .btn span:after {
  transform: rotate(135deg);
  top: 12px;
}
.okr-left-dropdown .list {
  display: none;
  z-index: 999;
  position: absolute;
  top: 29px;
  right: 0;
  left: 0;
  margin: 0;
  padding: 0 0 10px 0;
  background: #fff;
  border: 1px solid #a3a4a6;
}
.okr-left-dropdown.active .list {
  display: block;
  overflow: auto;
  max-height: 200px;
}
.okr-left-dropdown .list li {
  list-style: none;
}
.okr-left-dropdown .list li.selected {
  background: #f1f1f1;
}
.okr-left-dropdown .list button {
  width: 100%;
}
.okr-left-dropdown .list span {
  display: block;
  overflow: hidden;
  width: calc(100% - 30px);
  padding: 5px 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
<script>
import { mapState, mapActions } from "vuex";
import Todo from "./modal/Todo.vue";
import HeaderNoti from "./modal/Noti";
import TargetCall from "./modal/TargetCall.vue";
import PrevQrtUnit from "./modal/PrevQrtUnit";
import { version } from 'vuedraggable';
import ManagerOtp from "./modal/ManagerOtp"
export default {
  data() {
    return {
      show: true,
      isActive: false,
      isManager: null,
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-right",
          duration: 3000,
        },
      },
      sharUse: null,
      cfrcUse: null,
      okrUse: null,
      externalOkrUse: null,
      tenantId : null,
      accessType : null,
      okrSubMenuHtml: null,
      resOkrSubMenuHtml : null,
      groupId: null, // 개인공간 때문에 추가 => 추후 삭제 예정
      roleUserFnc : false,
      roleTypeUser : false,// 팀장권한 확인.

      decisionNewCheck : this.$i18nUtil.trans("button.MainLeft.decision","의사 결정"),

      todo: this.$i18nUtil.trans("entity.todo","할 일").replace(/\s/g, ''),
      // 관리자 otp
      otpId : null,
      type : "SMS",
      userId : "",
      password : "",
      accessDevice : false,
      otpNum:""
    };
  },
  mounted() {
    /* tenant 별 메뉴명 및 okr 서브메뉴 구성 */
    this.initMainLeft();
    EventBus.$on("showOkrMain", () => {
      this.goOkrMain();
    });
    this.checkRoleUserFnc();
    this.checkRoleTypeUser();

    if(this.eventBackYn){
      this.setEventBackYn(false);
      if(this.showNotiListPopup){
        this.showNoti();
      }
      if(this.showCallListPopup){
        this.showTargetCall();
      }

      this.setShowNotiListPopup(false);
      this.setShowCallListPopup(false);
    }
  },
  created() {
    //알림 조회.
    this.setNoneNotiReadYn();
    //호출 조회
    this.setNoneCallReadYn();
    //의사결정 조회
    this.setTimeDecisionReadYn();
    //할 일 조회
    this.setTodoConfirmYn();
    this.setLoginCookie();
  },
  methods: {
    ...mapActions("modals", ["showModal"]),
    ...mapActions("modals", ["showToast"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("noti", ["setNoneNotiReadYn"]),
    ...mapActions("noti", ["setNoneCallReadYn"]),
    ...mapActions("todo", ["setTodoConfirmYn"]),
    ...mapActions("okrQrt", ["setUnitCode"]),
    ...mapActions("decision", ["setTimeDecisionReadYn"]), 
    ...mapActions("noti", ["setShowCallListPopup","setShowNotiListPopup","setEventBackYn"]),
    todoNewCheck() {
      let todoTitle = this.tenantId === '203' ? this.$i18nUtil.trans('button.MainLeft.mytodo','나의 할일', {todo: this.todo}) : this.$i18nUtil.trans('entity.todo','할 일')
      if (this.todoConfirmYn) {
        todoTitle+= '<span class="ico-new"></span>';
      }
      return todoTitle;
    },
    initMainLeft() {
      if(localStorage.getItem("sharUse") !== null) {
        this.sharUse = localStorage.getItem("sharUse");
      }
      if(localStorage.getItem("cfrcUse") !== null) {
        this.cfrcUse = localStorage.getItem("cfrcUse");
      }
      if(localStorage.getItem("tenantId") !== null) {
        this.tenantId = localStorage.getItem("tenantId");
      }
      if(localStorage.getItem("okrUse") !== null) {
        this.okrUse = localStorage.getItem("okrUse");
      }
      if(localStorage.getItem("accessType") !== null) {
        this.accessType = localStorage.getItem("accessType");
      }
      if(this.accessType === "IN") {  /* 내부망 & tenantId != 418502 에서 접근 시에만 okr 메뉴 setting */
          if(this.tenantId !== "418502") {
            this.getMenuHtmlToRedis();
            // if(localStorage.getItem("selectedUnitCode") == null) {
            //   this.createOkrSubMenuHtml();
            // } else {
            //   let chgUnitCode = null;
            //   let prevUnitCode = localStorage.getItem("selectedUnitCode");
            //   if(document.getElementById("okrCurrentUnitId") != null) {
            //     chgUnitCode = document.getElementById("okrCurrentUnitId").value;
            //   }
            //   if(prevUnitCode != chgUnitCode) {
            //     this.createOkrSubMenuHtml();
            //   } else {
            //     this.getMenuHtmlToRedis();
            //   }
            // }
          }
      }
      else { // 외부망
        // document.getElementById("okrMenuBar").style.display ="none";
        /* 2021-11-19 외부망 OKR 메뉴 표시 조건 수정
         * 1. okrUse 사용자 && externalOkrUse 사용자
         */
        if (this.okrUse === 'true') {
          if (localStorage.getItem("externalOkrUse") === null) {
            this.setExternalOkrUse();
          }
          else if (localStorage.getItem("externalOkrUse") !== null) {
            this.externalOkrUse = localStorage.getItem("externalOkrUse");
          }
        }
      }
    },
    checkRoleUserFnc(){
      let obj = this;
      let reqData = {
        url : "/api/org/checkRoleUserFnc",
        method : "post",
        params : {
          funcId : "SYS_DLPL_VIEW"
        }
      };
      this.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        if (res != null) {
          if(res.result){
            obj.roleUserFnc = res.result;
          }
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    /* 팀장권한(TLD) 확인 */
    checkRoleTypeUser() {
      let obj = this;
      let reqData = {};
      reqData.params = {
        roleType: "TLD",
      };
      reqData.url = "/api/org/checkRoleTypeUser";
      reqData.method = "post";            
      
      obj.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        obj.roleTypeUser = res.result;              
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    setExternalOkrUse() {
      let obj = this;
      let reqData = {
          url : "/api/org/getCodeValueList",
          method : "post",
          params : {
              cdCategory: 'config.okr',
              cdKey: 'external.menu.use'  
          }
      };
      obj
      .COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        if (res.result !== null) {
          obj.externalOkrUse = res.result.length > 0 ? res.result[0].cdValue : 'false';
          localStorage.setItem("externalOkrUse", obj.externalOkrUse);
        }
      })
      .catch(function(err) {
          console.log(err);
      });
    },
    setLoginCookie(){
      let obj = this;
      let reqData = {
        url : "/api/auth/setLoginCookie",
        method : "post"
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        if(res != null){
          if (res.errorCode != null) {
            console.log(res.errorCode);
          }
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    otpYn(){
      let curUrl = localStorage.getItem("returnUrl");
      let cosysUrl = "cosys";
      //현재 페이지가 관리자 페이지일 경우 새로고침
      if(curUrl!=null){
        if(curUrl.includes(cosysUrl)){
            this.$router.go();
        }else{
          if(confirm(this.$i18nUtil.trans("message.MainLeft.003","관리자 화면으로 이동하기 위해 SMS인증이 필요합니다. SMS인증을 하시겠습니까?"))) {
          this.showAdmin();
          }
        }
      }else{
          if(confirm(this.$i18nUtil.trans("message.MainLeft.003","관리자 화면으로 이동하기 위해 SMS인증이 필요합니다. SMS인증을 하시겠습니까?"))) {
          this.showAdmin();
        }
      }
    },
    showAdmin() {
      // if(confirm(this.$i18nUtil.trans("message.MainLeft.001","관리자 화면으로 이동하기 위해 재 로그인이 필요합니다. 관리자 화면으로 이동하시겠습니까?"))) {
      //   this.handleLogout();
      // }
      let obj = this;
      let reqData = {
          url: "/api/auth/produceOtp",
          method: "post",
          params: {
              otpId: obj.otpId,
              userId: localStorage.getItem('userId'),
              certType : obj.type,
              password: "",
              accessDevice : obj.accessDevice
          }
      };
      obj
      .COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
          if(res.errorCode !== null) {
              let errorCode = res.errorCode;
              if(errorCode === "NOT_EXIST_CELL_PHONE_NO") {
                  let info = {
                      title: obj.$i18nUtil.trans("title.dialog.notice", "알림"),
                      contents: obj.$i18nUtil.trans("message.IntegrateLogin.011", "핸드폰 번호가 존재하지 않습니다."),
                      button: obj.$i18nUtil.trans("button.dialog.confirm", "확인")
                  };
                  obj.handleDialog(info);
              }
          } else {
              if (res.result.otpId != null) {
                  obj.otpInputField = true;
                  obj.isValidPw = true;
                  obj.resOtp = res.result.otp;
                  obj.otpId = res.result.otpId;
                  obj.time = 300;
                  obj.handleCountDown();

                  //dev or stg일 경우 OTP번호 노출
                  if(res.result.otp != null){
                    obj.otpNum = res.result.otp;
                    console.log("OPT 번호 :: " + res.result.otp);
                  }
                  let info = {
                      title: obj.$i18nUtil.trans("title.dialog.notice", "알림"),
                      contents: obj.$i18nUtil.trans("AG014", "인증번호가 전송되었습니다."),
                      button: obj.$i18nUtil.trans("button.dialog.confirm", "확인")
                  };
                  obj.showAlertDialog(
                    obj.$i18nUtil.trans("AG014", "인증번호가 전송되었습니다."),
                    obj.$i18nUtil.trans("title.dialog.notice", "알림"),
                    { width: "400px" },
                    obj.$i18nUtil.trans("button.dialog.confirm", "확인"),
                    obj.showOtpModal,
                    null
                  );
              }
          }
      })
      .catch(function(err) {
          console.log(err);
      });
    },
    async handleLogout() {
      await this.logoutNeo();
      await this.logoutCowork();
    },
    logoutCowork() {
      let obj = this;
      let reqData = {
        url : "/api/auth/logout",
        method : "post",
        params : {
          loginType: 'WEB'
        }
      };
      this.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        alert(obj.$i18nUtil.trans("TG001"));
        localStorage.clear();
        localStorage.setItem("returnUrl", "/cosys/fileDlpBlock");
        localStorage.setItem("returnUrls", ",/cosys/fileDlpBlock");
        if(location.host.indexOf("hanwhalife.com") > -1 && location.host != "cpdev.hanwhalife.com"){
          obj.$router.push("/hcpsso/sso_login");
        }
        else{
          obj.$router.push("/reLogin");
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    showOtpModal() {
      const modalInfo = {
        title: this.$i18nUtil.trans("title.Noti.001","알림"),
        width: "550px", 
        height: "564px", 
        obj: this.$modal,
        component: ManagerOtp,
        otpId : this.otpId,
        certType : this.type,
        accessDevice : this.accessDevice,
        otpNum:this.otpNum
      };

      this.showModal(modalInfo);
    },
        /* OTP 인증 만료 시간 */
    handleCountDown(timer) {
        if (timer !== null) {
            clearInterval(this.timer);
            this.timer = setInterval(() => {
                if (this.time > 0) {
                    this.time--;
                } else {
                    clearInterval(this.timer);
                }
            }, 1000);
        } else {
            this.timer = setInterval(() => {
                if (this.time > 0) {
                    this.time--;
                } else {
                    clearInterval(this.timer);
                }
            }, 1000);
        }
    },
    async handleLogout() {
      await this.logoutNeo();
      await this.logoutCowork();
    },
    logoutNeo() {
      let obj = this;
      let reqData = {
        url : "/neo/logout",
        method : "post"
      };
      this.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        // console.log("################");
        // console.log(res);
        // console.log("################");
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    showTodo() {
      let hanwha = $(location).attr("origin");
      window.open(
        hanwha + "/general/todoNewPage",
        "_blank",
        "width=1264, height=800"
      );
    },
    /* 팀원 할 일 팝업 */
    showTodoTeam() {
      let hanwha = $(location).attr("origin");
      let width = 1264;
      if(this.$i18nUtil.getLanguage() === 'en') width = 1500;
      window.open(
          hanwha + "/general/TodoTeam",
          "_blank",
          "width="+width+", height=800"
      );
    },
    showTargetCall() {
      const modalInfo = {
        title: this.$i18nUtil.trans("title.TargetCall.001","호출"),
        width: "800px", //$(window).width(),
        height: "664px", //$(window).height(),
        obj: this.$modal,
        component: TargetCall,
      };

      this.showModal(modalInfo);
    },
    showDecision() {
      let hanwha = $(location).attr("origin");
      window.open(
        hanwha + "/general/perDeci",
        "_blank",
        "width=1264, height=800"
      );
    },
    showNoti() {
      const modalInfo = {
        title: this.$i18nUtil.trans("title.Noti.001","알림"),
        width: "800px", //$(window).width(),
        height: "664px", //$(window).height(),
        obj: this.$modal,
        component: HeaderNoti,
      };

      this.showModal(modalInfo);
    },
    deleteMenuHtmlToRedis() {
      let obj = this;
      let reqData  = {
        url :  "/api/org/okr/deleteMenuHtmlToRedis",
        method : "post",
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        if (res != null) {
          console.log("deleteMenuHtmlToRedis result ::"+res.result);
        }
      })
      .catch(function (err) {
        console.log(err);
      })
    },
    createOkrSubMenuHtml(changeGbn) {
      let obj = this;
      let reqData = {};
      reqData.req = this.req;
      reqData.method = "post";
      reqData.url = "/neo/branch/common/slo/loginOKR.mvc?destination=/neo/services/okr/co/coCommon/getMenuHtml.mvc";

      if(obj.okrUse === 'true'){
        obj.showLoadingbar();
      }
      obj.COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          let decodeRes = atob(res);
          let replaceVal = decodeRes.replace(/\+/g, '%20');
          let subMenuHtml = decodeURIComponent(replaceVal);
          if (subMenuHtml == null || subMenuHtml == '') {
            console.log("createOkrSubMenuHtml fail !!!");
          }
          obj.resOkrSubMenuHtml = subMenuHtml;
        })
        .then(function() {
          if(document.getElementById('okrCurrentUnitId') != null) {
            localStorage.setItem("selectedUnitCode", document.getElementById('okrCurrentUnitId').value);
          }
        })
        .then(function() {
          if (obj.resOkrSubMenuHtml != null && obj.resOkrSubMenuHtml != '') {
            obj.setMenuHtmlToRedis(changeGbn);
          } else {
            console.log("setMenuHtmlToRedis cannot call !!!");
          }
        })
        .catch(function (err) {
          if(obj.okrUse === 'true'){
            obj.hideLoadingbar();
          }
          console.log(err);
        });
    },
    setMenuHtmlToRedis(changeGbn) {
      let obj = this;
      let reqData  = {
        url :  "/api/org/okr/setMenuHtml",
        method : "post",
        params : {
          menuHtml : null
        }
      };
      // console.log("## setMenuHtmlToRedis");
      // console.log(changeUserDept);
      // if(changeUserDept) {
      //   if (obj.okrSubMenuHtml) {
      //     reqData.params.menuHtml = obj.okrSubMenuHtml;
      //     console.log("setMenuHtmlToRedis 1");          
      //   } else {
      //     reqData.params.menuHtml = obj.resOkrSubMenuHtml;
      //     console.log("setMenuHtmlToRedis 2");          
      //   }
      // } else {
      //   reqData.params.menuHtml = obj.resOkrSubMenuHtml
      //   // reqData.params.menuHtml = obj.okrSubMenuHtml
      //   console.log("setMenuHtmlToRedis 3");
      // }
      reqData.params.menuHtml = obj.resOkrSubMenuHtml
      console.log("setMenuHtmlToRedis 3");
      obj.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        if(obj.okrUse === 'true'){
          obj.hideLoadingbar();
        }
        if(res.errorCode == null) {
          obj.getMenuHtmlToRedis(changeGbn);
        }
      })
      .catch(function (err) {
        console.log(err);
      })
    },
    getMenuHtmlToRedis(changeGbn) {
      let obj = this;
      let reqData  = {
        url :  "/api/org/okr/getMenuHtml",
        method : "post",
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        if (res != null) {
          if (res.result != null && res.result != '') {
            obj.okrSubMenuHtml = res.result;
          } else {
            obj.createOkrSubMenuHtml();
          }
        }
        if(changeGbn){
          console.log("call goOkrMain");
          obj.goOkrMain();
        }
      })
      .catch(function (err) {
        console.log(err);
      })
    },
    viewOkrWindow() {
      let obj = this;
      let reqData  = {
        url :  "/api/auth/slo/reverseHrOkrSlo",
        method : "post",
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        if (res !== null && res.result !== null) {
          let slo_p_ota = res.result.slo_p_ota;
          let gwCode = res.result.gwCode;
          let targetUrl = "/";
          let hostUrl = res.result.hostUrl;
          let okrSloUri = "/login";
          // POST
          // obj.$refs.HR_OKR_SLO_IF.method = 'POST';
          // obj.$refs.HR_OKR_SLO_IF.target = '_blank';
          // obj.$refs.HR_OKR_SLO_IF.action = hostUrl + okrSloUri;
          // obj.$refs.HR_OKR_SLO_IF.slo_p_ota.value = slo_p_ota;
          // obj.$refs.HR_OKR_SLO_IF.gwCode.value = gwCode;
          // obj.$refs.HR_OKR_SLO_IF.targetUrl.value = targetUrl;
          // obj.$refs.HR_OKR_SLO_IF.submit();
          // GET
          let url = hostUrl + okrSloUri + "?slo_p_ota=" + slo_p_ota + "&gwCode=" + gwCode + "&targetUrl=" + targetUrl;
          // window.open(url, "HR_OKR_SLO_POPUP", "top=0, left=0, width=" + window.screen.width + ", height=" + window.screen.height);
          window.open(url, "_blank");
        }
      })
      .catch(function (err) {
        console.log(err);
      })
    },
    goOkrMain() {
      let mainAction = null;
      let mainAuthType = null;
      let mainListName = null;
      let mainMenuName = null;
      let mainUsageMenuId = null;
      let okrSelectedQrtCd = null;
      let currentUnitId = null;
      let hqDeptSelectUnitId = null;
      if(document.getElementById("okrMainAction") !== null) {
        mainAction = document.getElementById("okrMainAction").value;
      }
      if(document.getElementById("okrMainAuthType") !== null) {
        mainAuthType = document.getElementById("okrMainAuthType").value;
      }
      if(document.getElementById("okrMainListName") !== null) {
        mainListName = document.getElementById("okrMainListName").value;
      }
      if(document.getElementById("okrMainMenuName") !== null) { 
        mainMenuName = document.getElementById("okrMainMenuName").value;
      }
      if(document.getElementById("okrMainUsageMenuId") !== null) {
        mainUsageMenuId = document.getElementById("okrMainUsageMenuId").value;
      }
      if(document.getElementById("okrSelectedQrtCd") !== null) {
        okrSelectedQrtCd = document.getElementById("okrSelectedQrtCd").value;
      }
      if(document.getElementById("okrCurrentUnitId") !== null) {
        currentUnitId = document.getElementById("okrCurrentUnitId").value;
      }
      if(document.getElementById("okrHqDeptSelectUnitId") !== null) {
        hqDeptSelectUnitId = document.getElementById("okrHqDeptSelectUnitId").value;
      }

      if(mainAction !== null) {
        let randomParam = new Date().getTime();
        this.$router.push({
          name: "okrMain",
          query: { q: randomParam },
          params: {
            destination: mainAction,
            authType: mainAuthType,
            listName: mainListName,
            fileName: "",
            menuName: mainMenuName,
            usageMenuId: mainUsageMenuId,
            selectedQrtCd: okrSelectedQrtCd,
            currentUnitId: currentUnitId,
            hqDeptSelectUnitId: hqDeptSelectUnitId,
          },
        });
      }
    },
    changeUserPrevUnit(selectQrtInfo) {//이전 유닛 변경
      let obj = this;
      let prevCode = selectQrtInfo.selectedQrtCd + "^" + selectQrtInfo.selectedQrtUnit;
      let reqData = {
        url : "/neo/services/okr/co/coCommon/changeUserDeptUnit.mvc?prevCode=" + prevCode,
        //url : "/neo/services/okr/common/changeUserDeptUnit.mvc?prevCode=" + prevCode,
        method : "get",
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function (res) {
        let decodeMainData = atob(res);
        let replaceMainData = decodeMainData.replace(/\+/g, '%20');
        let mainDataHtml = decodeURIComponent(replaceMainData);
        let mainData = document.getElementById('mainData');
        let parent = mainData.parentNode;
        parent.removeChild(mainData);
        parent.innerHTML += mainDataHtml;
      })
      .then(function() {
        // let currentUnit = null;
        // if(document.getElementById('okrCurrentUnitId') !== null) {
        //   currentUnit = document.getElementById('okrCurrentUnitId').value;
        //   obj.setCurrentUnitCode(currentUnit);
        // }
        console.log("changeUnit :: " + document.getElementById('okrCurrentUnitId'));
        //this.selectedUnitCode = ;
      })
      .then(function() {
        obj.goOkrMain();
      })
      .catch(function (err) {
        console.log(err);
      });
    },
  },
  watch: {
    selectedPrevQrt : function() {
      this.deleteMenuHtmlToRedis();
      this.changeUserPrevUnit(this.selectQrtInfo);
    },
    readYn(){
      if(this.readYn > 0){
        this.decisionNewCheck = this.$i18nUtil.trans("button.MainLeft.decision","의사 결정")+"<span class='ico-new'></span>";
      }
    },
    todoConfirmYn(){
      this.todoNewCheck();
    },
    externalOkrUse() {
      if (this.externalOkrUse === 'true' && this.okrUse === 'true' && this.tenantId !== "418502") {
        this.getMenuHtmlToRedis();
      }
    }
  },
  computed: {
    ...mapState("decision", ["readYn"]),
    ...mapState("noti", ["noneNotiReadYn"]),
    ...mapState("noti", ["noneCallReadYn"]),
    ...mapState("todo", ["todoConfirmYn"]),
    ...mapState("introInfo", ["isInternalUser"]),
    ...mapState("okrQrt", ["selectQrtInfo", "selectedPrevQrt"]),
    ...mapState("okrQrt", ["selectedUnitCode"]),
    ...mapState("noti", ["showCallListPopup","showNotiListPopup","eventBackYn"]),
    okrSubMenu() {
      return {
        template: this.okrSubMenuHtml,
        data() {
          return {
            pageIndex: 0,
            okrLeftDropdownArr: [],
            okrLeftDropdownReturnVal: "",
          };
        },
        methods: {
          ...mapActions("modals", ["showModal"]),
          ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
          okrLeftDropdownTrigger() {
            event.stopPropagation
              ? event.stopPropagation()
              : (event.cancelBubble = true);
            let _this = event.currentTarget;
            let wrap = _this.parentNode;
            let menu = _this.parentNode.querySelectorAll("li");
            wrap.classList.toggle("active");
            if (this.okrLeftDropdownArr.indexOf(_this) < 0) {
              let thisObj = this;
              let addEvent = function (obj) {
                let btn = obj.querySelector("button");
                btn.addEventListener("click", function () {
                  let $this = this;
                  wrap.classList.remove("active");
                  if (thisObj.okrLeftDropdownReturnVal == "1") {
                    //alert('기타 기능 추가 영역');
                  } else {
                    _this.querySelector("span").innerText = $this.innerText;
                  }
                });
              };
              [].forEach.call(menu, function (obj) {
                addEvent(obj);
              });
              window.addEventListener("click", function () {
                wrap.classList.remove("active");
              });
              this.okrLeftDropdownArr.push(_this);
            }
          },
          okrLeftDropdownOtherFn(val, isLink) {
            this.okrDeleteMenuHtmlToRedis(val, isLink); // 부서 목록 변경 시 기존의 Redis 삭제.
            // if (isLink) {
            //   if (val == "-" || val == "prevQrtUnit") {
            //     this.okrLeftDropdownReturnVal = "1";
            //   }
            //   this.changeUserDeptUnit(val);
            // }
          },
          okrDeleteMenuHtmlToRedis(val, isLink) {
            let obj = this;
            let reqData  = {
              url :  "/api/org/okr/deleteMenuHtmlToRedis",
              method : "post",
            };
            obj.COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
              if (res != null) {
                console.log("okrDeleteMenuHtmlToRedis result ::"+res.result);
                if (isLink) {
                  if (val == "-" || val == "prevQrtUnit") {
                    obj.okrLeftDropdownReturnVal = "1";
                  }
                  obj.changeUserDeptUnit(val);
                }
              }
            })
            .catch(function (err) {
              console.log(err);
            })
          },
          changeUserDeptUnit(unitCode) {
            console.log("call v2 changeUserDeptUnit");
            console.log(unitCode);
            if (unitCode == "-" || unitCode == "prevQrtUnit") {
              if (unitCode == "prevQrtUnit") {
                this.prevQrtUnitLayer();
              }
              return;
            }
            let obj = this;
            /*
            var f = document.submitForm;		
            f.action = "http://127.0.0.1/neo/services/okr_v2/common/changeUserDeptUnit.mvc";
            f.unitCode.value = unitCode;
            f.target = "submitIframe";
            f.submit();		
            */
            let reqData = {
              //url : "/neo/branch/common/slo/loginOKR.mvc?destination=/neo/services/okr/common/changeUserDeptUnit.mvc?unitCode=" + unitCode,
              url : "/neo/services/okr/co/coCommon/changeUserDeptUnit.mvc?unitCode=" + unitCode,
              method : "get"
            };
            obj.COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function (res) {
              console.log("prev :: " + document.getElementById('okrCurrentUnitId').value);
              let decodeMainData = atob(res);
              let replaceMainData = decodeMainData.replace(/\+/g, '%20');
              let mainDataHtml = decodeURIComponent(replaceMainData);
              let mainData = document.getElementById('mainData');
              let parent = mainData.parentNode;
              parent.removeChild(mainData);
              parent.innerHTML += mainDataHtml;
            })
            .then(function() {
              obj.$parent.createOkrSubMenuHtml(true);
            })
            // .then(function() {
            //   obj.$parent.goOkrMain();
            // })
            .catch(function (err) {
              console.log(err);
            });
          },
          prevQrtUnitLayer() {//이전 파트 및 유닛 구해 오는 레이어 팝업
            const modalInfo = {
                width: "800px",
                obj: this.$modal,
                component: PrevQrtUnit
            };
            this.showModal(modalInfo);
            /*
            $.ajax({
                url: 'http://127.0.0.1/neo/services/okr/common/prevQrtUnitLayer.mvc',
                dataType: "html",
                data: {
                },
                success: function(data){
                console.log(data);
                $("#okrMenuDiv2").html(data);
                },
                error: function(e){
                  console.log(e);
                }
            }); 
            */
          },          
          goOkrMenu(id) {
            if (
              $("#okrRegYn").val() == "N" &&
              (id == "menuT4M111B" ||
                id == "menuT3M111B" ||
                id == "menuT2M111B" ||
                id == "menuT1M111B")
            ) {
              alert(this.$i18nUtil.trans("message.MainLeft.002","OKR 등록 기간이 아닙니다."));
              return;
            }
            if ($("#okrDisableSecondStepFunction").val() == "true") {
              // 아래 서비스들의 경우 return 처리
              if (
                id == "menuT4M12" ||
                id == "menuT3M12" ||
                id == "menuT2M12" ||
                id == "menuT1M12" ||
                id == "menuT0M12"
              ) {
                alert(this.$i18nUtil.trans("message.preparation","서비스 준비중입니다."));
                return;
              }
            }
            if($("#okrDisableSessionUser").val() == "true") {
              if(
                id == "menuT3M13" ||
                id == "menuT2M13" ||
                id == "menuT1M13"
              ) {
                alert(this.$i18nUtil.trans("message.preparation","서비스 준비중입니다."));
                return;
              }
            }
            this.selectMenuItem_(id, false);
          },
          sessionTeamUserPop() {
            // let paramAction = "/neo/services/okr/session/sessionTeamUserPopup.mvc";
            // window.open(paramAction, "wlT5M01", "top=0, left=0, width=" + window.screen.width + ", height=" + window.screen.height);
            let paramAction =
                "/neo/services/okr/session/sessionTeamUserPopup.mvc";
            window.open('/neo/branch/common/slo/loginOKR.mvc?destination='+paramAction, "wlT5M01", "top=0, left=0, width=" + window.screen.width + ", height=" + window.screen.height);
          },
          sessionHqPop() {
            /* 본부장 세션 */
            let paramAction = "/neo/services/okrAdmin/session/sessionViewPopupHqView.mvc";
            window.open('/neo/branch/common/slo/loginOKR.mvc?destination='+paramAction, "wlT5M01", "top=0, left=0, width=" + window.screen.width + ", height=" + window.screen.height);
          },
          sessionMgrUserPop() {
            /* 조직원 성과관리 현황 */
            var paramAction = "/neo/services/okrAdmin/session/sessionMgrUserView.mvc";
            window.open('/neo/branch/common/slo/loginOKR.mvc?destination='+paramAction, "wlT5M01", "top=0, left=0, width=" + 1350 + ", height=" + 800);
          },
          selectMenuItem_(id, isFirstClick) {
            // let obj = this;
            // obj.showLoadingbar();
            let setAlarmParam = false;
            if ($("#okrAccess").val() == "alarm") {
              setAlarmParam = true;
            }

            isFirstClick = isFirstClick || false;

            // 메뉴CSS설정
            //selectMenu(id);

            let paramAction = "";
            let paramAuthType = "";
            let paramListName = "";
            let paramUsageMenuId = "";
            let okrSelectedQrtCd = null;
            let currentUnitId = null;

            //--------------------------------------------------------------------------------------------------------------------------
            // 실/본부장
            if (id == "menuT4M01") {
              //HOME
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/home/ohT4M01.mvc";
              paramAuthType = "";
              paramListName = "wlT4M01";
              paramUsageMenuId = "ohT4M01";
            } else if (id == "menuT4M11") {
              //OKR 등록/수정
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/myOkrGet.mvc";
              paramAuthType = "T4";
              paramListName = "wlT4M11";
              paramUsageMenuId = "myOkrT4M11";
            } else if (id == "menuT4BM11") {
              //OKR 등록/수정
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/myOkrGet.mvc?theme=Y";
              paramAuthType = "T4B";
              paramListName = "wlT4M11";
              paramUsageMenuId = "";
            } else if (id == "menuT4M111") {
              //OKR 등록/수정 (OKR 등록 화면)
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrRegFormGet.mvc";
              paramAuthType = "T4";
              paramListName = "wlT4M11";
              paramUsageMenuId = "";
            } else if (id == "menuT4M111B") {
              //OKR 등록/수정 (OKR 등록 화면)
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrRegFormGet.mvc";
              paramAuthType = "T4B";
              paramListName = "wlT4M11";
              paramUsageMenuId = "";
            } else if (id == "menuT4M112") {
              //OKR 등록/수정 (OKR 수정 화면)
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrModFormGet.mvc";
              paramAuthType = "T4";
              paramListName = "wlT4M11";
              paramUsageMenuId = "";
            } else if (id == "menuT4BM112") {
              //OKR 등록/수정 (OKR 수정 화면)
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrModFormGet.mvc";
              paramAuthType = "T4B";
              paramListName = "wlT4M11";
              paramUsageMenuId = "";
            } else if (id == "menuT4M12") {
              //업데이트 내역
              alert(this.$i18nUtil.trans("message.preparation","서비스 준비중입니다."));
              return;
            } else if (id == "menuT4M22") {
              //피드백
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/feedback/teamFeedback.mvc";
              paramAuthType = "";
              paramListName = "wlT4M22";
              paramUsageMenuId = "feedbackT4M22";
            } else if (id == "menuT4M31") {
              //OKR지도
              if ($("#okrDisableSecondStepFunction").val() == "true") {
                alert(this.$i18nUtil.trans("message.preparation","서비스 준비중입니다."));
                return;
              }
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/map/main.mvc";
              paramAuthType = "";
              paramListName = "wlT4M31";
              paramUsageMenuId = "mapT4M31";
            } else if (id == "menuT4M32") { 
              // 조직별 OKR
              if ($("#okrDisableSecondStepFunction").val() == "true") {
                alert(this.$i18nUtil.trans("message.preparation","서비스 준비중입니다."));
                return;
              }
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/okrByOrg.mvc";
              paramAuthType = "T0E1";
              paramListName = "wlT4M32";
              paramUsageMenuId = "okrByOrgT4M32";
            } else if (id == "menuT4M51") {
              // 월간 피드백
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/monthlyFb/omT3M01.mvc";
              paramAuthType = "";
              paramListName = "wlT4M51";
              paramUsageMenuId = "omT4M51";
            }
            else if (id == "menuT4M61") {
              // 다면평가 진단자 설정
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/eval/oeT3M01.mvc";
              paramAuthType = "";
              paramListName = "wlT4M61";
              paramUsageMenuId = "oeT3M01";
            }
            else if (id == "menuT0M11D") {
              // 나의 조직 OKR (본부장)
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/myOkrGet4Head.mvc";
              paramAuthType = "T0D1";
              paramListName = "wlT0M04";
              paramUsageMenuId = "myOkrT0M04";
            }
            //--------------------------------------------------------------------------------------------------------------------------
            // 팀장
            else if (id == "menuT3M01") {
              //HOME
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/home/ohT3M01.mvc";
              paramAuthType = "";
              paramListName = "wlT1M01";
              paramUsageMenuId = "ohT3M01";
            } else if (id == "menuT3M11") {
              //OKR 등록/수정
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/myOkrGet.mvc";
              paramAuthType = "T3";
              paramListName = "wlT3M11";
              paramUsageMenuId = "myOkrT3M11";
            } else if (id == "menuT3BM11") {
              //OKR 등록/수정
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/myOkrGet.mvc?theme=Y";
              paramAuthType = "T3B";
              paramListName = "wlT3M11";
              paramUsageMenuId = "";
            } else if (id == "menuT3M111") {
              //OKR 등록/수정 (OKR 등록 화면)
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrRegFormGet.mvc";
              paramAuthType = "T3";
              paramListName = "wlT3M11";
              paramUsageMenuId = "";
            } else if (id == "menuT3M111B") {
              //OKR 등록/수정 (OKR 등록 화면)
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrRegFormGet.mvc";
              paramAuthType = "T3B";
              paramListName = "wlT3M11";
              paramUsageMenuId = "";
            } else if (id == "menuT3M112") {
              //OKR 등록/수정 (OKR 수정 화면)
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrModFormGet.mvc";
              paramAuthType = "T3";
              paramListName = "wlT3M11";
              paramUsageMenuId = "";
            } else if (id == "menuT3BM112") {
              //OKR 등록/수정 (OKR 수정 화면)
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrModFormGet.mvc";
              paramAuthType = "T3B";
              paramListName = "wlT3M11";
              paramUsageMenuId = "";
            } else if (id == "menuT3M12") {
              //업데이트 내역
              alert(this.$i18nUtil.trans("message.preparation","서비스 준비중입니다."));
              return;
            } else if (id == "menuT3M21") {
              //업무관리
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/task/otT3M01.mvc";
              paramAuthType = "";
              paramListName = "wlT3M21";
              paramUsageMenuId = "taskT3M21";
            } else if (id == "menuT3M22") {
              //피드백
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/feedback/teamFeedback.mvc";
              paramAuthType = "";
              paramListName = "wlT3M22";
              paramUsageMenuId = "feedbackT3M22";
            } else if (id == "menuT3M31") {
              //OKR지도
              if ($("#okrDisableSecondStepFunction").val() == "true") {
                alert(this.$i18nUtil.trans("message.preparation","서비스 준비중입니다."));
                return;
              }
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/map/main.mvc";
              paramAuthType = "";
              paramListName = "wlT3M31";
              paramUsageMenuId = "mapT3M31";
            } else if (id == "menuT3M32") {
              // 조직별 OKR
              if ($("#okrDisableSecondStepFunction").val() == "true") {
                alert(this.$i18nUtil.trans("message.preparation","서비스 준비중입니다."));
                return;
              }
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/okrByOrg.mvc";
              paramAuthType = "T0E1";
              paramListName = "wlT3M32";
              paramUsageMenuId = "okrByOrgT3M32";
            } else if (id == "menuT3M41") {
              //팀원관리
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/unit/ouT3M01.mvc";
              paramAuthType = "";
              paramListName = "wlT3M41";
              paramUsageMenuId = "";
            } else if (id == "menuT3M51") {
              // 월간 피드백
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/monthlyFb/omT3M01.mvc";
              paramAuthType = "";
              paramListName = "wlT3M51";
              paramUsageMenuId = "omT3M51";
            } else if (id == "menuT3M61") {
              // 다면평가 진단자 설정
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/eval/oeT3M01.mvc";
              paramAuthType = "";
              paramListName = "wlT3M61";
              paramUsageMenuId = "oeT3M01";
            }
            //--------------------------------------------------------------------------------------------------------------------------
            // 파트장
            else if (id == "menuT2M01") {
              //HOME
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/home/ohT2M01.mvc";
              paramAuthType = "";
              paramListName = "wlT2M01";
              paramUsageMenuId = "ohT2M01";
            } else if (id == "menuT2M11") {
              //OKR 등록/수정
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/myOkrGet.mvc";
              paramAuthType = "T2";
              paramListName = "wlT2M11";
              paramUsageMenuId = "myOkrT2M11";
            } else if (id == "menuT2BM11") {
              //OKR 등록/수정
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/myOkrGet.mvc?theme=Y";
              paramAuthType = "T2B";
              paramListName = "wlT2M11";
              paramUsageMenuId = "";
            } else if (id == "menuT2M111") {
              //OKR 등록/수정 (OKR 등록 화면)
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrRegFormGet.mvc";
              paramAuthType = "T2";
              paramListName = "wlT2M11";
              paramUsageMenuId = "";
            } else if (id == "menuT2M111B") {
              //OKR 등록/수정 (OKR 등록 화면)
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrRegFormGet.mvc";
              paramAuthType = "T2B";
              paramListName = "wlT2M11";
              paramUsageMenuId = "";
            } else if (id == "menuT2M112") {
              //OKR 등록/수정 (OKR 수정 화면)
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrModFormGet.mvc";
              paramAuthType = "T2";
              paramListName = "wlT2M11";
              paramUsageMenuId = "";
            } else if (id == "menuT2BM112") {
              //OKR 등록/수정 (OKR 수정 화면)
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrModFormGet.mvc";
              paramAuthType = "T2B";
              paramListName = "wlT2M11";
              paramUsageMenuId = "";
            } else if (id == "menuT2M12") {
              //업데이트 내역
              alert(this.$i18nUtil.trans("message.preparation","서비스 준비중입니다."));
              return;
            } else if (id == "menuT2M21") {
              //업무관리
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/task/otT2M01.mvc";
              paramAuthType = "";
              paramListName = "wlT2M21";
              paramUsageMenuId = "taskT2M21";
            } else if (id == "menuT2M22") {
              //피드백
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/feedback/myFeedback.mvc";
              if ($("#okrAccess").val() == "alarm") {
                if (setAlarmParam) {
                  setAlarmParam = false;
                  let listType = $("#okrListType").val();
                  let taskId = $("#okrTaskId").val();
                  let feedbackId = $("#okrFeedbackId").val();
                  paramAction =
                    paramAction +
                    "?access=alarm&listType=" +
                    listType +
                    "&taskId=" +
                    taskId +
                    "&feedbackId=" +
                    feedbackId;
                }
              }
              paramAuthType = "";
              paramListName = "wlT2M22";
              paramUsageMenuId = "feedbackT2M22";
            } else if (id == "menuT2M31") {
              //OKR지도
              if ($("#okrDisableSecondStepFunction").val() == "true") {
                alert(this.$i18nUtil.trans("message.preparation","서비스 준비중입니다."));
                return;
              }
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/map/main.mvc";
              paramAuthType = "";
              paramListName = "wlT2M31";
              paramUsageMenuId = "mapT2M31";
            } else if (id == "menuT2M32") {
              // 조직별 OKR
              if ($("#okrDisableSecondStepFunction").val() == "true") {
                alert(this.$i18nUtil.trans("message.preparation","서비스 준비중입니다."));
                return;
              }
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/okrByOrg.mvc";
              paramAuthType = "T0E1";
              paramListName = "wlT2M32";
              paramUsageMenuId = "okrByOrgT2M32";
            } else if (id == "menuT2M41") {
              //파트/유닛관리
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/unit/ouT2M02.mvc";
              paramAuthType = "";
              paramListName = "wlT2M41";
              paramUsageMenuId = "";
            } else if (id == "menuT2M51") {
              // 월간 피드백
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/monthlyFb/omT3M01.mvc";
              paramAuthType = "";
              paramListName = "wlT2M51";
              paramUsageMenuId = "omT2M51";
            }
            //--------------------------------------------------------------------------------------------------------------------------
            // 멤버
            else if (id == "menuT1M01") {
              //HOME
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/home/ohT1M01.mvc";
              paramAuthType = "T1";
              paramListName = "wlT1M01";
              paramUsageMenuId = "ohT1M01";
            } else if (id == "menuT1M11") {
              //OKR 등록/수정
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/myOkrGet.mvc";
              paramAuthType = "T1";
              paramListName = "wlT1M11";
              paramUsageMenuId = "myOkrT1M11";
            } else if (id == "menuT1BM11") {
              //OKR 등록/수정
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/myOkrGet.mvc?theme=Y";
              paramAuthType = "T1B";
              paramListName = "wlT1M11";
              paramUsageMenuId = "";
            } else if (id == "menuT1M111") {
              //OKR 등록/수정 (OKR 등록 화면)
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrRegFormGet.mvc";
              paramAuthType = "T1";
              paramListName = "wlT1M11";
              paramUsageMenuId = "";
            } else if (id == "menuT1M111B") {
              //OKR 등록/수정 (OKR 등록 화면)
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrRegFormGet.mvc";
              paramAuthType = "T1B";
              paramListName = "wlT1M11";
              paramUsageMenuId = "";
            } else if (id == "menuT1M112") {
              //OKR 등록/수정 (OKR 수정 화면)
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrModFormGet.mvc";
              paramAuthType = "T1";
              paramListName = "wlT1M11";
              paramUsageMenuId = "";
            } else if (id == "menuT1BM112") {
              //OKR 등록/수정 (OKR 수정 화면)
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrModFormGet.mvc";
              paramAuthType = "T1B";
              paramListName = "wlT1M11";
              paramUsageMenuId = "";
            } else if (id == "menuT1M12") {
              //업데이트 내역
              alert(this.$i18nUtil.trans("message.preparation","서비스 준비중입니다."));
              return;
            } else if (id == "menuT1M21") {
              //업무관리
              paramAuthType = "T1";
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/task/otT1M01.mvc";
              if ($("#okrAccess").val() == "alarm") {
                if (setAlarmParam) {
                  setAlarmParam = false;
                  let taskId = $("#okrTaskId").val();
                  paramAction = paramAction + "?access=alarm&taskId=" + taskId;
                }
              }
              paramListName = "wlT1M21";
              paramUsageMenuId = "taskT1M21";
            } else if (id == "menuT1M22") {
              //피드백
              paramAuthType = "T1";
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/feedback/myFeedback.mvc";
              if ($("#okrAccess").val() == "alarm") {
                if (setAlarmParam) {
                  setAlarmParam = false;
                  let listType = $("#okrListType").val();
                  let taskId = $("#okrTaskId").val();
                  let feedbackId = $("#okrFeedbackId").val();
                  paramAction =
                    paramAction +
                    "?access=alarm&listType=" +
                    listType +
                    "&taskId=" +
                    taskId +
                    "&feedbackId=" +
                    feedbackId;
                }
              }
              paramListName = "wlT1M22";
              paramUsageMenuId = "feedbackT1M22";
            } else if (id == "menuT1M23") {
              //피드백 요청하기
              paramAuthType = "";
              paramAction = "/neo/services/okr/main.mvc?page=/neo/services/okr/feedback/ofT1M04.mvc";
              paramListName = "wlT1M23";
              paramUsageMenuId = "feedbackT1M23";
            } else if (id == "menuT1M24") {
              //피드백 확인하기
              paramAuthType = "";
              paramAction = "/neo/services/okr/main.mvc?page=/neo/services/okr/feedback/myFeedbackNew.mvc";
              paramListName = "wlT1M24";
              paramUsageMenuId = "feedbackT1M24";
            } else if (id == "menuT1M25") {
              //피드백 답변하기
              paramAction = "/neo/services/okr/main.mvc?page=/neo/services/okr/feedback/teamFeedbackNew.mvc";
              paramAuthType = "";
              paramListName = "wlT1M25";
              paramUsageMenuId = "feedbackT1M25";
            } else if (id == "menuT1M31") {
              //OKR지도
              if ($("#okrDisableSecondStepFunction").val() == "true") {
                alert(this.$i18nUtil.trans("message.preparation","서비스 준비중입니다."));
                return;
              }
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/map/main.mvc";
              paramAuthType = "T1";
              paramListName = "wlT1M31";
              paramUsageMenuId = "mapT1M31";
            } else if (id == "menuT1M32") {
              // 조직별 OKR
              if ($("#okrDisableSecondStepFunction").val() == "true") {
                alert(this.$i18nUtil.trans("message.preparation","서비스 준비중입니다."));
                return;
              }
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/okrByOrg.mvc";
              paramAuthType = "T0E1";
              paramListName = "wlT1M32";
              paramUsageMenuId = "okrByOrgT1M32";
            } else if (id == "menuT1M41") {
              //다면평가
              if ($("#okrDisableSecondStepFunction").val() == "true") {
                alert(this.$i18nUtil.trans("message.preparation","서비스 준비중입니다."));
                return;
              }
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/eval/oeT1M01.mvc";
              paramAuthType = "";
              paramListName = "wlT1M41";
              paramUsageMenuId = "";
            } else if (id == "menuT1M51") {
              // 월간 피드백 
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/monthlyFb/omT1M01.mvc";
              paramAuthType = "";
              paramListName = "wlT1M51";
              paramUsageMenuId = "omT1M51";
            }
            // 옵저버
            else if (id == "menuT5M01") {
              //HOME
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/home/ohT5M01.mvc";
              paramAuthType = "T1";
              paramListName = "wlT5M01";
              paramUsageMenuId = "ohT5M01";
            } else if (id == "menuT5M02") {
              //대시보드
              if ($("#okrDisableSecondStepFunction").val() == "true") {
                alert(this.$i18nUtil.trans("message.preparation","서비스 준비중입니다."));
                return;
              }
              let activeTarget = "btn-innovation";
              paramUsageMenuId = "dashboard";
              // paramAction =
              //   "/neo/services/okr/home/ohT3M02Popup.mvc?activeTarget=" + activeTarget;
              // window.open(paramAction, "wlT5M01", "top=0, left=0, width=" + window.screen.width + ", height=" + window.screen.height);
              paramAction =
                "/neo/services/okr/main.mvc|page=/neo/services/okr/home/ohT3M02Popup.mvc?activeTarget=" + activeTarget;
              window.open('/neo/branch/common/slo/loginOKR.mvc?destination='+paramAction, "wlT5M01", "top=0, left=0, width=" + window.screen.width + ", height=" + window.screen.height);
              return;
              // paramAuthType = "T1";
              // paramListName = "wlT5M01";
              // let activeTarget = "btn-innovation";
              // paramAction =
              //   "/neo/services/okr/home/ohT3M02Popup.mvc?activeTarget=" +
              //   activeTarget;
              // paramAuthType = "T1";
              // paramListName = "wlT5M01";
              // paramUsageMenuId = "dashboardT5M02";
            } else if(id == "menuT5M03") {
              // paramAction = "/neo/services/okr/dashboard/okrUnitDashboard.mvc";
              paramAuthType = "T1";
              paramListName = "wlT5M01";
              // window.open(paramAction, "wlT5M01", "top=0, left=0, width=" + window.screen.width + ", height=" + window.screen.height);
              paramAction =
                "/neo/services/okr/main.mvc|page=/neo/services/okr/dashboard/okrUnitDashboard.mvc";
              window.open('/neo/branch/common/slo/loginOKR.mvc?destination='+paramAction, "wlT5M01", "top=0, left=0, width=" + window.screen.width + ", height=" + window.screen.height);
              return;
            } else if(id == 'menuT3M13') {
              let targetUserId = null;
              if(document.getElementById("targetUserId") !== null) {
                targetUserId = document.getElementById("targetUserId").value;
              }
              paramAction =
                "/neo/services/okrAdmin/session/sessionUserPopup.mvc?targetUserId=" + targetUserId;
              window.open('/neo/branch/common/slo/loginOKR.mvc?destination='+paramAction, "wlT5M01", "top=0, left=0, width=800, height=800");
              return;
              // paramAction = "/neo/services/okr/session/sessionUser.mvc";
              // paramAuthType = "T3";
              // paramListName = "wlT3M13";
              // paramUsageMenuId = "sessionUser";
            } else if(id == 'menuT2M13') {
              paramAction = "/neo/services/okr/session/sessionUser.mvc";
              paramAuthType = "T2";
              paramListName = "wlT2M13";
              paramUsageMenuId = "sessionUser";
            } else if(id == 'menuT1M13') {
              paramAction = "/neo/services/okr/session/sessionUser.mvc";
              paramAuthType = "T1";
              paramListName = "wlT1M13";
              paramUsageMenuId = "sessionUser";
            } else if (id == "menuT5M31") {
              //OKR지도
              if ($("#okrDisableSecondStepFunction").val() == "true") {
                alert(this.$i18nUtil.trans("message.preparation","서비스 준비중입니다."));
                return;
              }
              // paramAuthType = "T1";
              // paramListName = "wlT5M01";
              // paramUsageMenuId = "mapT5M31";
              // paramAction = "/neo/services/okr/map/popup.mvc";
              paramAuthType = "T1";
              paramListName = "wlT5M01";
              paramUsageMenuId = "mapT5M31";
              // window.open(paramAction, "wlT5M01", "top=0, left=0, width=" + window.screen.width + ", height=" + window.screen.height);
              paramAction =
                "/neo/services/okr/main.mvc|page=/neo/services/okr/map/popup.mvc";
              window.open('/neo/branch/common/slo/loginOKR.mvc?destination='+paramAction, "wlT5M01", "top=0, left=0, width=" + window.screen.width + ", height=" + window.screen.height);
              return;
            }
            else if(id == 'menuT5M51') {
              paramAction = "/neo/services/okr/main.mvc?page=/neo/services/okr/monthlyFb/omT1M01.mvc";
              paramAuthType = "";
              paramListName = "wlT5M51";
              paramUsageMenuId = "omT5M51";
            }
            //--------------------------------------------------------------------------------------------------------------------------
            // 관리자
            else if (id == "menuT0M11A") {
              //[전략] 사업부 OKR 등록/수정
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/myOkrGet4Admin.mvc";
              paramAuthType = "T0A";
              paramListName = "wlT0M11";
              paramUsageMenuId = "";
            } else if (id == "menuT0M111A") {
              //[전략] 사업부 OKR 등록/수정 (OKR 등록 화면)
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrRegFormGet.mvc";
              paramAuthType = "T0A";
              paramListName = "wlT0M11";
              paramUsageMenuId = "";
            } else if (id == "menuT0M112A") {
              //[전략] 사업부 OKR 등록/수정 (OKR 수정 화면)
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrModFormGet.mvc";
              paramAuthType = "T0A";
              paramListName = "wlT0M11";
              paramUsageMenuId = "";
            } else if (id == "menuT0M11B") {
              //[테마] 사업부 OKR 등록/수정
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/myOkrThemeGet.mvc?theme=Y";
              paramAuthType = "T0B";
              paramListName = "wlT0M11";
              paramUsageMenuId = "";
            } else if (id == "menuT0M111B") {
              //[테마] 사업부 OKR 등록/수정 (OKR 등록 화면)
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrRegFormGet.mvc";
              paramAuthType = "T0B";
              paramListName = "wlT0M11";
              paramUsageMenuId = "";
            } else if (id == "menuT0M112B") {
              //[테마] 사업부 OKR 등록/수정 (OKR 수정 화면)
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrModFormGet.mvc";
              paramAuthType = "T0B";
              paramListName = "wlT0M11";
              paramUsageMenuId = "";
            } else if (id == "menuT0M12") {
              //승인관리
              alert(this.$i18nUtil.trans("message.preparation","서비스 준비중입니다."));
              return;
            }
            // 관리자 > OKR 조회
            else if (id == "menuT0M13A") {
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/mgr/okrList4Mgr.mvc";
              paramAuthType = "";
              paramListName = "wlT0M13A";
              paramUsageMenuId = "";
            }
            // 관리자 > 파트/유닛 멤버조회
            else if (id == "menuT0M13B") {
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/mgr/memberList4Mgr.mvc";
              paramAuthType = "";
              paramListName = "wlT0M13B";
              paramUsageMenuId = "";
            }
            // 관리자 > 파트/유닛 멤버조회
            else if (id == "menuT0M14") {
              paramAction =
                "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/mgr/memberList4Mgr.mvc";
              paramAuthType = "";
              paramListName = "wlT0M14";
              paramUsageMenuId = "";
            }
            //본부/실/사업부 OKR 관리
            else if ( id == 'menuT0M11C' ) {
              // $("#authType").val("T0C");
              // f.action = "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/myOkrGet4Admin.mvc";
              paramAuthType = "T0C";
              paramAction = "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/myOkrGet4Admin.mvc";
            }
            //본부/실/사업부 OKR 관리 (OKR 등록 화면)
            else if ( id == 'menuT0M111C' ) {
              // $("#authType").val("T0C");
              // f.action = "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrRegFormGet.mvc";
              paramAuthType = "T0C";
              paramAction = "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrRegFormGet.mvc";
            }
            //본부/실/사업부 OKR 관리 (OKR 수정 화면)
            else if ( id == 'menuT0M112C' ) {
              // $("#authType").val("T0C");
              // f.action = "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrModFormGet.mvc";
              paramAuthType = "T0C";
              paramAction = "/neo/services/okr/main.mvc?page=/neo/services/okr/okr/form/okrModFormGet.mvc";
            }

            let paramMenuName = id;
            let paramFileName = id.replace("menu", "wl");
            let randomParam = new Date().getTime();
            if(document.getElementById("okrSelectedQrtCd") !== null) {
              okrSelectedQrtCd = document.getElementById("okrSelectedQrtCd").value;
            }
            if(document.getElementById("okrCurrentUnitId") !== null) {
              currentUnitId = document.getElementById("okrCurrentUnitId").value;
            }
            // obj.hideLoadingbar();
            this.$router.push({
              name: "okrMain",
              query: { q: randomParam },
              params: {
                destination: paramAction,
                authType: paramAuthType,
                listName: paramListName,
                fileName: paramFileName,
                menuName: paramMenuName,
                usageMenuId: paramUsageMenuId,
                selectedQrtCd: okrSelectedQrtCd,
                currentUnitId: currentUnitId,
              },
            });
          },
        },
      };
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/main/MainLeft.vue